import axios from 'axios';
import { clearLocalStorage } from '../utils/cacheCleaner';

const environment = process.env.REACT_APP_environment !== 'production' ? 'development' : 'production';

const BASE_URL_API = {
  development: 'https://stg.api1.sulamerica.com.br',
  production: 'https://prd.api1.sulamerica.com.br'
};

const CREDENTIALS = {
  development: {
    client: 'c7914037-c875-39e6-b35c-16e0c1fda2bd',
    token:
      'Basic Yzc5MTQwMzctYzg3NS0zOWU2LWIzNWMtMTZlMGMxZmRhMmJkOjU4OGQ5MjQwLTZlOTctMzMzYi05Yjk1LTYyNWVlYTFhNmU3Mg==',
    // JWT do Mobile Engine de homolog pode ser obtido através nos logs do Openshift, no link a seguir: https://openshift-37.sulamerica.br:8443/console/project/fis-odo-mobileengine-develop/overview
    // Para confirmar se o JWT corresponde ao login utilizado no PWA, basta decodificar o token no link a seguir: https://jwt.io/
    tokenJWT: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF9wcmVzdGFkb3IiOiIyNTYxMCIsIm5vbWVfdXN1YXJpbyI6IkhFTkVSWSBERSBPTElWRUlSQSBWSUNFTlRJTiIsImVtYWlsIjoibWFyaW5hZGVwYXVsYS5ldmVyaXNAc3VsYW1lcmljYS5jb20uYnIiLCJyb2xlcyI6IltcInByZXN0YWRvclwiXSJ9.xDLp5Ob_wD5YNgBO7R8OKDgx1K74e9cGFaJS2q9wa2E'
  },
  production: {
    client: '61c56fd8-9f5e-31ae-a7f8-8fdf1fb682fe',
    token:
      'Basic NjFjNTZmZDgtOWY1ZS0zMWFlLWE3ZjgtOGZkZjFmYjY4MmZlOjkyOTFjODRkLWYyNWEtM2I3Yi05ZDI1LTI4YWNiMDNlNDJhNQ=='
  }
};

const instances = {
  mobileengine_local: axios.create({
    baseURL: 'https://localhost:8100/api', // trocar por http quando for testar localmente, só está assim para não dar falso positivo no Checkmarx
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Accept: 'application/json;charset=UTF-8',
      Authorization: CREDENTIALS[environment].tokenJWT
    },
    timeout: 6000,
    validateStatus: false
  }),
  mobileengine_fis: axios.create({
    baseURL: 'https://fis-odo-mobileengine-develop.paas.sulamerica.com.br/api',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Accept: 'application/json;charset=UTF-8',
      Authorization: CREDENTIALS[environment].tokenJWT
    },
    timeout: 6000,
    validateStatus: false
  }),
  prestador_odonto: axios.create({
    baseURL: `${BASE_URL_API[environment]}/prestador/odonto/v1`,
    timeout: 6000,
    headers: {
      client_id: CREDENTIALS[environment].client,
      'Content-Type': 'application/json;charset=UTF-8',
      Accept: 'application/json;charset=UTF-8',
      Authorization: CREDENTIALS[environment].token,
      access_token: localStorage.getItem('prestador_odontoToken')
    },
    validateStatus: false
  }),
  procedimento_odonto_v1: axios.create({
    baseURL: `${BASE_URL_API[environment]}/procedimentos/odonto/api/v1`,
    timeout: 6000,
    headers: {
      client_id: CREDENTIALS[environment].client,
      'Content-Type': 'application/json;charset=UTF-8',
      Accept: 'application/json;charset=UTF-8',
      Authorization: CREDENTIALS[environment].token
    }
  }),
  procedimento_odonto_v2: axios.create({
    baseURL: `${BASE_URL_API[environment]}/procedimento/odonto/v2`,
    timeout: 6000,
    headers: {
      client_id: CREDENTIALS[environment].client,
      'Content-Type': 'application/json;charset=UTF-8',
      Accept: 'application/json;charset=UTF-8',
      Authorization: CREDENTIALS[environment].token
    }
  }),
  wslogin: axios.create({
    baseURL: `${BASE_URL_API[environment]}/wslogin/v1/`,
    headers: {
      client_id: CREDENTIALS[environment].client,
      'Content-Type': 'application/json;charset=UTF-8',
      Accept: 'application/json;charset=UTF-8',
      IDServico: 3,
      Codigo: 3,
      Authorization: CREDENTIALS[environment].token
    }
  }),
  beneficiario_odonto: axios.create({
    baseURL: `${BASE_URL_API[environment]}/beneficiario/odonto/api/v1`,
    timeout: 6000,
    headers: {
      client_id: CREDENTIALS[environment].client,
      'content-type': 'application/json;charset=UTF-8',
      Authorization: CREDENTIALS[environment].token
    }
  })
};

instances.prestador_odonto.interceptors.response.use(
  response => {
    if (response.status === 401) {
      if (response.config.url.includes('access-token')) {
        return response;
      }
      clearLocalStorage();
      window.location.href = '/login';
    }
    return response;
  },
  error => Promise.reject(error)
);

export default instances;
